import type { Locale } from '../locales';
import { en } from './en';
import { hr } from './hr';
import { sl } from './sl';

/**
 * The catalogue's shape, derived from English rather than declared.
 *
 * <p>Declaring it as an interface means writing every string four times — once in the
 * type and once per locale — and the copy that rots is always the type. Deriving it keeps
 * the guarantee that matters (a key missing from `sl` does not compile) at no duplication,
 * which is what made staying on a typed object viable through a full extraction instead
 * of moving to JSON files that check nothing.
 */
export type Messages = typeof en;

/** Adding a locale without a catalogue fails to compile. */
export const MESSAGES = { en, sl, hr } satisfies Record<Locale, Messages>;
